export const columns=[    
       { 
        field: "name", 
        header: "Component",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"name")}  className="">          
                <p className="w-[6rem] cursor-pointer text-blue-600 hover:text-blue-800" >
                {row?.name}
                </p>
              </div>
            </>
          ),
       },
       { 
        field: "componentType", 
        header: "Component Type",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"componentType")}  className="">          
                <p className="w-[6rem]" >
                {row?.componentType?.name}
                </p>
              </div>
            </>
          ),
       },
      //  { 
      //   field: "permissions", 
      //   header: "permissions",
      //   accessor: (row,handleCellClick) => (
      //       <>
      //         <div  onClick={()=>handleCellClick(row,"permissions")}  className="">          
      //           <p className="w-[6rem]">
      //            {row?.permissions && row?.permissions?.length && row?.permissions?.map((item)=>`${item?.permissionName}`)}
      //           </p>
      //         </div>
      //       </>
      //     ), 
      //  },
       { 
        field: "active", 
        header: "Active",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"active")}  className="">          
                <p className="w-[6rem]">
                 {JSON.stringify(row?.active)||""}               
                </p>
              </div>
            </>
          ), 
       },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};